import {SegmentedControl} from '../../../card/segmented-control';

import {FREQUENCY_SEGMENT_OPTIONS} from './consts';
import type {
    RecurrenceDueDateFormSetters,
    RecurrenceDueDateFormState,
} from './recurrence-due-date-mode-form-types';
import type {CycleUnit} from './task-custom-recurrence-popover';

interface Props {
    values: RecurrenceDueDateFormState;
    setters: RecurrenceDueDateFormSetters;
}

export function RecurrenceFrequencySegmentedControl(props: Props) {
    return (
        <SegmentedControl
            buttonOptions={FREQUENCY_SEGMENT_OPTIONS}
            selectedValue={props.values.cycleUnit}
            setSelectedValue={(value) => {
                props.setters.setCycleUnit(value as CycleUnit);
            }}
            hasPadding={false}
            variant='separated'
            isAnimated={true}
        />
    );
}
